import MaskedTextField from '@/common/components/MaskedTextField'
import TextField from '@/common/components/TextField'
import { useCardDetails } from '@/common/hooks/queries/useCardDetails'
import useDebounce from '@/common/hooks/useDebounce'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { ConsumptionValidationSchema } from '../schemas/create.schema'
import EquipmentInfo from './EquipmentInfo'
import { cardStatusAvailableToConsumption } from '../constants/cardStatusAvailableToConsumption.constant'

interface EssentialInformationFormProps {
  clearForm: (exceptCardIdentifier?: boolean) => void
}

const EssentialInformationForm = ({ clearForm }: EssentialInformationFormProps) => {
  const {
    watch,
    register,
    setValue,
    formState: { errors },
  } = useFormContext<ConsumptionValidationSchema>();

  const cardIdentifierFromForm = watch('card_identifier')

  const [debouncedCardIdentifier, setDebouncedCardData] = useDebounce(cardIdentifierFromForm || '')

  const { data: cardDetails, isPending: isPendingCard, dataUpdatedAt: cardDetailsUpdatedAt } = useCardDetails(debouncedCardIdentifier || '')

  useEffect(() => {
    setValue('card_available_to_consume', !!cardDetails?.id && (cardStatusAvailableToConsumption).includes(cardDetails.status));

    if (!cardDetails?.id && !isPendingCard)
      return clearForm(true)
  }, [cardDetails?.id, isPendingCard])

  useEffect(() => {
    setValue('category_bypass_consumption_usage_validations', !!cardDetails?.equipment?.category_bypass_consumption_usage_validations);
  }, [cardDetailsUpdatedAt]);

  return (
    <div className="flex flex-col gap-3 sm:gap-6 h-full">
      <p className="text-lg sm:text-[20px] font-bold">Insira ou digite o código do cartão</p>

      <div className='flex flex-col gap-4 sm:gap-6'>
        <TextField
          label="Código do cartão ou Placa do equipamento"
          name='card_identifier'
          errorMessage={errors?.card_id?.message}
          defaultValue={cardIdentifierFromForm}
          onChange={(e) => {
            const value = (e.target as HTMLInputElement).value.replace(/\s+/g, '');

            if (value !== cardIdentifierFromForm) {
              clearForm(true);
            }

            setValue('card_identifier', value);
            setDebouncedCardData(value);
          }}
          isLoading={isPendingCard && !!cardIdentifierFromForm}
          markAsRequired
        />

        {!isPendingCard && !!debouncedCardIdentifier && (
          <>
            <EquipmentInfo cardDetails={cardDetails} setValue={setValue} />

            {cardDetails?.id && (cardStatusAvailableToConsumption).includes(cardDetails.status) && (
              <MaskedTextField
                mask="000.000.000-00"
                label="Usuário"
                markAsRequired
                placeholder="Digite o CPF"
                errorMessage={errors?.buyer_cpf?.message}
                inputMode="numeric"
                pattern="[0-9]*"
                {...register('buyer_cpf')}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default EssentialInformationForm
